<template>
    <el-tooltip
        :content="text"
        :disabled="!isOverflowing"
        placement="top"
        effect="dark"
        popper-class="disease-table-tooltip"
    >
        <span ref="text" class="overflow-text" @mouseenter="measureOverflow">{{ text }}</span>
    </el-tooltip>
</template>

<script>
export default {
    name: 'OverflowText',
    props: {
        text: { type: String, default: '' },
    },
    data() {
        return { isOverflowing: false };
    },
    methods: {
        measureOverflow() {
            const element = this.$refs.text;
            this.isOverflowing = element.scrollWidth > element.clientWidth;
        },
    },
};
</script>

<style scoped>
.overflow-text {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>

<!-- Tooltip 挂载到 body，使用专属全局类名，不能放在 scoped 样式中。 -->
<style>
.el-tooltip__popper.disease-table-tooltip {
    max-width: 500px;
    max-width: min(500px, calc(100vw - 24px));
    box-sizing: border-box;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
}
</style>
